<nb-card>
  <nb-card-header>
    App Settings
  </nb-card-header>
  <nb-card-body>
    <div *ngIf="appSettings?.apkUrl">
      <a [href]="appSettings.apkUrl" target="_blank">Download APK</a>
    </div>
    <div *ngIf="appSettings?.ipaUrl">
      <a [href]="appSettings.ipaUrl" target="_blank">Download IPA</a>
    </div>
    <div *ngIf="appSettings?.abbUrl">
      <a [href]="appSettings.abbUrl" target="_blank">Download ABB</a>
    </div>
    <button *ngIf="!disabled" class="mr-2" nbButton (click)="runBuild()">Run Build</button>
    <button *ngIf="!disabled" nbButton (click)="syncTfToGhl()">Sync Trainer friend to ghl</button>
    <div class="form-group row">
      <label class="col-sm-4 col-form-label">Go High Level Api Key</label>
      <div class="col-sm-8">
        <input nbInput [disabled]="disabled" type="text" [(ngModel)]="user.gHLApiKey"/>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4 col-form-label">Is Custom App In Production</label>
      <div class="col-sm-8">
        <nb-toggle [disabled]="disabled" [checked]="user.isCustomAppInProduction" (checkedChange)="changeIsCustomAppInProduction($event)"></nb-toggle>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4 col-form-label">Is Custom App enabled</label>
      <div class="col-sm-8">
        <nb-toggle [disabled]="disabled" [checked]="user.customAppEnabled" (checkedChange)="changeCustomAppEnabled($event)"></nb-toggle>
      </div>
    </div>
    <div class="form-group row" *ngIf="userSettings">
      <label class="col-sm-4 col-form-label">App Store url</label>
      <div class="col-sm-8">
        <input nbInput [disabled]="disabled" type="text" [(ngModel)]="userSettings.appStoreUrl"/>
      </div>
    </div>
    <div class="form-group row"  *ngIf="userSettings">
      <label class="col-sm-4 col-form-label">Play store url</label>
      <div class="col-sm-8">
        <input nbInput [disabled]="disabled" type="text"  [(ngModel)]="userSettings.playStoreUrl"/>
      </div>
    </div>
<!--
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">App Store Password</label>
        <div class="col-sm-8">
          <input nbInput type="text" [(ngModel)]="configurations.appStorePassword"/>
        </div>
      </div> -->
      <p *ngIf="configurations.version">Current App Version is : {{configurations.version}}</p>
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Key ID</label>
        <div class="col-sm-8">
          <input nbInput [disabled]="disabled" type="text" [(ngModel)]="configurations.keyId"/>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Issuer ID</label>
        <div class="col-sm-8">
          <input nbInput [disabled]="disabled" type="text" [(ngModel)]="configurations.issuerId"/>
        </div>
      </div>
      <!-- <div class="form-group row">
        <label class="col-sm-4 col-form-label">Username</label>
        <div class="col-sm-8">
          <input nbInput type="text" [(ngModel)]="configurations.username"/>
        </div>
      </div> -->
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Team ID</label>
        <div class="col-sm-8">
          <input nbInput [disabled]="disabled" type="text" [(ngModel)]="configurations.teamId"/>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Team Name</label>
        <div class="col-sm-8">
          <input nbInput [disabled]="disabled" type="text" [(ngModel)]="configurations.teamName"/>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Bundle ID</label>
        <div class="col-sm-8">
          <input nbInput [disabled]="disabled" type="text" [(ngModel)]="configurations.bundleId"/>
        </div>
      </div>
      <!-- <div class="form-group row">
        <label class="col-sm-4 col-form-label">Branch Name</label>
        <div class="col-sm-8">
          <input nbInput type="text" [(ngModel)]="configurations.branchName"/>
        </div>
      </div> -->
      <div class="form-group row" *ngIf="!disabled">
        <label class="col-sm-4 col-form-label">
          tokenFileUpload
        </label>
        <div class="col-sm-8">
          <input nbInput type="file" accept="*.p8" (change)="tokenFileUpload($event)"/>
        </div>
      </div>
      <button *ngIf="!disabled" nbButton (click)="saveChanges()">save app settings</button>

  </nb-card-body>
</nb-card>
